var divider_viewer_rtlignore_default = {
  "divider-container": "AmdN2",
  "divider-container--double": "_4iyQa",
  "divider": "_5UTn4",
  "divider--single": "KKX8y",
  "divider--double": "oXTdY",
  "divider--dashed": "oO36A",
  "divider--dotted": "qdNgn",
  "divider--small": "u0RZr",
  "divider--medium": "k4fAe",
  "divider--large": "ddQsF",
  "divider--left": "xu7Er",
  "divider--center": "g-G06",
  "divider--right": "mQjTR",
  "svgFixerContainer": "Lg3ep",
  "emptyChar": "RlVc2"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
